<template>
  <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <g>
      <rect fill="none" stroke-width="30" stroke-linejoin="round" stroke-linecap="round" height="44" width="276" x="121" y="391"/>
      <rect fill="none" stroke-width="30" stroke-linejoin="round" stroke-linecap="round" height="74.59" width="337.72" x="90.14" y="316.41"/>
      <path fill="none" stroke-width="30" stroke-linejoin="round" stroke-linecap="round" d="M259,63h0a53.85,53.85,0,0,0-53.76,56.91l11.17,196.5h85.18l11.17-196.5A53.85,53.85,0,0,0,259,63Z"/>
    </g>
  </svg>
</template>
